// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1MleL","choiceBoxes":"toolbarselects_choiceBoxes__3_vhg","simpleField":"toolbarselects_simpleField__36vcu"};